import { render, staticRenderFns } from "./GStudentRecordProfile.vue?vue&type=template&id=7734dbea&"
import script from "./GStudentRecordProfile.vue?vue&type=script&lang=ts&"
export * from "./GStudentRecordProfile.vue?vue&type=script&lang=ts&"
import style0 from "./GStudentRecordProfile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports